import { ITlfActionSetDelayedHierarchyUpdates, TlfContextProps } from "./interface";

/**
 * Updates the flag tracking whether ARS hierarchy changes are being deferred.
 *
 * @param state - Current TLF context state.
 * @param action - Set-delayed-updates action with the next flag value.
 * @returns Updated state with the delayed-update flag changed.
 */
export const tlf_setDelayedHierarchyUpdates = (
  state: TlfContextProps,
  action: ITlfActionSetDelayedHierarchyUpdates,
): TlfContextProps => ({
  ...state,
  delayedHierarchyUpdates: action.delayedHierarchyUpdates,
});
